import React from "react";

import {Modal} from "antd";

import {properties} from "../../../properties";

export function ModalWindow({title, isModalVisible, onCancel, onOk, children, scrollVisible = true, modalProps = {}}) {
	const headStyle = {
		borderColor: properties.kbrColors.pantone301Blue,
		color: properties.kbrColors.pantone301Blue,
	};

	const {bodyStyle: customBodyStyle, height, maxHeight, overflowY, ...restModalProps} = modalProps;

	const bodyStyle = {
		height: height ?? "60vh",
		maxHeight: maxHeight ?? "60vh",
		overflowY: overflowY ?? (scrollVisible ? "scroll" : "auto"),
		...customBodyStyle,
	};

	return (
		<Modal
			width={"40vw"}
			getContainer={false}
			title={<div style={headStyle}>{title}</div>}
			open={isModalVisible}
			onCancel={onCancel}
			onOk={onOk}
			bodyStyle={bodyStyle}
			{...restModalProps}>
			{children}
		</Modal>
	);
}
